import { request } from "../libs";

export default (serverUrl, searchList) => {
	return request(
		`${serverUrl}/search-list`,
		{
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: searchList
		}
	)
		.then(response => response.json());
};
